import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Skeleton } from "@tql/ui-components-react/tql/indicators";

export const LoaderCell = ({ ...gridProps }: GridCustomCellProps) => {
	return (
		<td {...gridProps.tdProps}>
			<span className={"trax-grid-skeleton"} data-testid={"grid-loading-cell"}>
				<Skeleton animation={{ type: "wave" }} shape={"text"} />
			</span>
		</td>
	);
};
